// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1097":"a5a120c7","7002":"83c5f6a5","7383":"a5a120c7","8002":"a5a120c7","8285":"b058c643"}[chunkId] + ".chunk.css";
};